import { StoreTrajectoryConsultValues } from '../store-trajectory-values'
import RecapGmvCard from './recap-gmv-card'
import RecapSegments from './recap-segments'
import { useTranslation } from 'react-i18next'

type StoreTrajectoryRecapProps = {
  storeTrajectoryConsultValues: StoreTrajectoryConsultValues
}

const StoreTrajectoryRecap = ({ storeTrajectoryConsultValues }: StoreTrajectoryRecapProps) => {
  const { t } = useTranslation()

  return (
    <div className="mg-store-trajectory-recap">
      <div
        className="mg-store-trajectory-recap-title vp-subtitle-l"
        data-testid="store-trajectory-recap-title-trajectory"
      >
        {t('general.trajectory.store.recap.trajectory')}
      </div>
      <div className="mg-store-trajectory-recap-gmv">
        <RecapGmvCard
          detailedGmv={storeTrajectoryConsultValues?.globalGmv?.omni}
          title={<span className="vp-title-s">{t('general.trajectory.store.recap.omni')}</span>}
          isOmni={true}
        />
        <RecapGmvCard
          detailedGmv={storeTrajectoryConsultValues?.globalGmv?.instore}
          title={<span className="vp-subtitle-l">{t('general.trajectory.store.recap.instore')}</span>}
          isOmni={false}
        />
        <RecapGmvCard
          detailedGmv={storeTrajectoryConsultValues?.globalGmv?.outstore}
          title={<span className="vp-subtitle-l">{t('general.trajectory.store.recap.outstore')}</span>}
          isOmni={false}
        />
      </div>
      <div
        className="mg-store-trajectory-recap-title vp-subtitle-l"
        data-testid="store-trajectory-recap-title-segments"
      >
        {t('general.trajectory.store.recap.segments')}
      </div>
      <RecapSegments instoreGmvSegments={storeTrajectoryConsultValues?.instoreGmvSegments} />
    </div>
  )
}

export default StoreTrajectoryRecap
